import { useMediaQuery } from "@mui/material";
import megaball from "assets/megaball.svg";
import React from "react";

const Ballinfo = ({ ball, isMegaBall, size = 48 }) => {
  const isPhone = useMediaQuery("(max-width: 768px)");
  return (
    <div
      className={
        isMegaBall
          ? "rounded-full aspect-1 flex justify-center items-center"
          : "rounded-full aspect-1 flex justify-center items-center"
      }
      style={{
        height: !isPhone ? size : (size = 32),
        background:
          "radial-gradient(63.67% 61.25% at 36.25% 21.25%, #FFFFFF 0%, #DBE3EF 100%)",
      }}
    >
      {isMegaBall && (
        <img
          alt=""
          src={megaball}
          className="absolute z-0"
          style={{ height: size }}
        />
      )}
      <p
        className={
          isMegaBall
            ? "text-black0 font-extrabold text-2xl md:text-xl absolute"
            : "font-extrabold text-2xl absolute md:text-xl"
        }
      >
        {ball}
      </p>
    </div>
  );
};

export default Ballinfo;
